import React from "react";

type PropsType = {
  color?: string;
  style?: React.CSSProperties;
  size?: number;
};

const Linkedin = ({
  size = 24,
  style = {},
  color = "currentColor",
}: PropsType) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      style={style}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M7.43555 8.3252C7.9398 8.37638 8.33296 8.80257 8.33301 9.32031V20.1553C8.33295 20.7075 7.88526 21.1553 7.33301 21.1553H4C3.44775 21.1553 3.00006 20.7075 3 20.1553V9.32031L3.00488 9.21777C3.05626 8.71369 3.48236 8.32031 4 8.32031H7.33301L7.43555 8.3252ZM15.666 7.41797C19.0541 7.41797 21.6658 10.3673 21.666 13.835V20.1553C21.666 20.7075 21.2183 21.1553 20.666 21.1553H17.333C16.7808 21.1553 16.3331 20.7075 16.333 20.1553V13.835C16.3328 13.3126 15.9607 13.0293 15.666 13.0293C15.3727 13.0293 15.0002 13.3122 15 13.835V20.1553C14.9999 20.7075 14.5522 21.1553 14 21.1553H10.666C10.1138 21.1553 9.66607 20.7075 9.66602 20.1553V13.835C9.66623 10.3672 12.279 7.41797 15.666 7.41797ZM5 19.1553H6.33301V10.3203H5V19.1553ZM15.666 9.41797C13.5313 9.41797 11.6662 11.318 11.666 13.835V19.1553H13V13.835C13.0002 12.3624 14.1195 11.0293 15.666 11.0293C17.2131 11.0293 18.3328 12.362 18.333 13.835V19.1553H19.666V13.835C19.6658 11.3179 17.8016 9.41797 15.666 9.41797ZM5.66699 2C7.21352 2.00019 8.33293 3.33323 8.33301 4.80566C8.33301 6.27816 7.21357 7.61114 5.66699 7.61133C4.12025 7.61133 3 6.27826 3 4.80566C3.00007 3.33312 4.1203 2 5.66699 2ZM5.66699 4C5.37281 4 5.00007 4.28371 5 4.80566C5 5.32771 5.37279 5.61133 5.66699 5.61133C5.96115 5.61112 6.33301 5.32751 6.33301 4.80566C6.33294 4.28391 5.96112 4.00021 5.66699 4Z"
        fill={color}
      />
    </svg>
  );
};

export default Linkedin;
